import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SeeMore from '~shared/ui/SeeMore';
import CellSelectionUS from './CellSelectionUS';

const DEFAULT_EXPANDED_ITEMS = 9;

const GridScoreSectionUS = ({ selectionsIds, headerName, sectionKey }) => {
    const [defaultExpandedCells, setDefaultExpandedCells] = useState([]);
    const [defaultCollapsedCells, setDefaultCollapsedCells] = useState([]);

    useEffect(() => {
        setSelectionRows();
    }, [selectionsIds]);

    const setSelectionRows = () => {
        const remainder = 3 - (selectionsIds.length % 3);
        const expanded = [];
        const collapsed = [];
        const emptyCell = <div className='cell-selection-empty'/>;

        selectionsIds.forEach((selection, index) => {
            const cell = <CellSelectionUS
                key={`selection-${selection}`}
                id={selection}
                sectionKey={sectionKey}
            />;

            if (index < DEFAULT_EXPANDED_ITEMS) {
                expanded.push(cell);
            } else {
                collapsed.push(cell);
            }
        });

        if (remainder !== 3) {
            if (selectionsIds.length < DEFAULT_EXPANDED_ITEMS) {
                for (let i = 0; i < remainder; i++) {
                    expanded.push(emptyCell);
                }
            } else {
                for (let i = 0; i < remainder; i++) {
                    collapsed.push(emptyCell);
                }
            }
        }

        setDefaultExpandedCells(expanded);
        setDefaultCollapsedCells(collapsed);
    };

    if (selectionsIds.length < 1) {
        return null;
    }

    return (
        <div className='score-grid-us__section'>
            <header>
                {headerName.toUpperCase()}
            </header>
            <div className='score-grid-us__section--selections' >
                {defaultExpandedCells}
            </div>
            {
                (defaultCollapsedCells.length !== 0)
                ? <SeeMore
                    collapseExtraClass="score-grid-us__see-more"
                    selections={[
                        <div
                            key={'collapsed-grid'}
                            className='score-grid-us__section--selections'
                        >
                            {defaultCollapsedCells}
                        </div>,
                    ]}
                />
                : null
            }
        </div>
    );
};

GridScoreSectionUS.propTypes = {
    selectionsIds: PropTypes.array.isRequired,
    headerName: PropTypes.string.isRequired,
    sectionKey: PropTypes.string.isRequired,
};

export default GridScoreSectionUS;
